class EditSystemForm {
    constructor() {
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.systemGroups = null;

        this.editSystemEvents();
    }
    async getSystemGroups(){
        return fetch('/systems/?do=getSystemGroups&organizationID=' + this.organizationID)
            .then(response => {
                if (!response.ok) {
                    throw new Error(response.statusText)
                }
                return response.json();
            });
    }
    /** Events for opening edit system modal form */
    editSystemEvents(){
        const thisClass = this;
        /** When user click on edit button redraw modal form and get system values */
        $(document).on('click', '.edit-system', function(e) {
            let systemID = $(this).parent()[0].id;
            thisClass.showEditSystemModal(systemID);
        });
        /** If url contains #edit-system - show system */
        if(window.location.href.includes('edit-system') && new URLSearchParams(window.location.search).get('systemID')){
            thisClass.showEditSystemModal(new URLSearchParams(window.location.search).get('systemID'));
        }

        $(document).on('click', '.back-to-edit-system', function(e) {
            let modalID = $(this).closest('.modal.fade.show')[0].attributes.id.value;
            bootstrap.Modal.getInstance(document.getElementById(modalID), {}).hide();
            new bootstrap.Modal(document.getElementById('edit_system_modal'), {}).show();
        });
    }
    /** Redraw edit system form by systemID */
    showEditSystemModal(systemID){
        new ModalLoading();
        naja.makeRequest('GET', '/systems/?do=getSystemInfo', {
            'systemID': systemID,
            'organizationID': this.organizationID
        }, {
            history: false // Prevent URL changes in browser history
        }).then(async (response) => {
            if (response) {
                if (!this.systemGroups) {
                    this.systemGroups = await this.getSystemGroups();
                }
                let editSystemModal = document.getElementById('edit_system_modal');

                if (response.systemInfo.isAdvanced) {
                    new AdvancedSystemForm('frm-generalForms-editSystemsForm-editSystemsForm', this.systemGroups, response.systemInfo.uuid, response.systemInfo.services);
                } else {
                    new BasicSystemForm('frm-generalForms-editSystemsForm-editSystemsForm', this.systemGroups, response.systemInfo.uuid);
                }
                this.editSystemInput();
                this.initTagifyInEditSystemForm(response.systemInfo.groupsArr);

                KTScroll.createInstances();
                KTMenu.createInstances();
                this.initDeleteSystem(editSystemModal, response.systemInfo);

                // Init all popovers
                const popoverTriggerList = [].slice.call(document.querySelectorAll('#edit_system_modal [data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });

                this.hideGeneralModals(editSystemModal);
                new ModalLoading(editSystemModal);
            }
        }).catch(error => {
            new ModalLoading();
            toastr.error('Unexpected error occurred. Please try it again later or contact our support team.');
        });
    }
    initDeleteSystem(editSystemModal, systemInfo){
        const thisClass = this;
        const deleteSystemButton = editSystemModal.querySelector('.delete-system');
        if(deleteSystemButton){
            deleteSystemButton.addEventListener('click', function () {
                Swal.fire({
                    html: `<span class="text-center text-primary">System `+(systemInfo.name !== undefined ? `<b>`+systemInfo.name+`</b> ` : ``)+`is going to be completely deleted!</span>`,
                    icon: "warning",
                    iconColor: "#FF5206",
                    buttonsStyling: false,
                    reverseButtons: true,
                    showCancelButton: true,
                    confirmButtonText: "Yes, delete!",
                    customClass: {
                        confirmButton: "btn btn-danger mt-0",
                        cancelButton: 'btn btn-light-primary mt-0',
                    },
                    showLoaderOnConfirm: true,
                    returnFocus: false,
                    preConfirm: () => {
                        return fetch('/systems?do=removeSystem&organizationID='+thisClass.organizationID+'&systemID='+systemInfo.uuid)
                            .then(response => {
                                if (!response.ok) {
                                    throw new Error(response.statusText)
                                }
                                return response.json();
                            }).catch(error => {
                                Swal.showValidationMessage(`Request failed: ${error}`)
                            });
                    },
                    allowOutsideClick: () => !Swal.isLoading(),
                    allowEscapeKey: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.isConfirmed) {
                        if(result.value.status === 'warning') {
                            toastr.error(result.value.massage);
                        }else if (result.value.status === 'success') {
                            toastr.success(result.value.massage);
                        }
                        bootstrap.Modal.getOrCreateInstance(editSystemModal).hide();
                        new PageDatatableReload();

                        let numberOfSystemsElement = $(".number-of-systems");
                        if(numberOfSystemsElement){
                            numberOfSystemsElement.text(parseInt(numberOfSystemsElement.text()) - 1);
                        }
                    }
                });
            });
        }
    }
    hideGeneralModals(editSystemModal){
        let editAccessCardModal = document.getElementById('edit_access_card_modal');
        if(editAccessCardModal && editAccessCardModal.classList.contains('show')){
            bootstrap.Modal.getInstance(editAccessCardModal).hide();
            new AddBackLinkToModal(editAccessCardModal, editSystemModal);
        }
        let createAccessCardModal = document.getElementById('create_access_card_modal');
        if(createAccessCardModal && createAccessCardModal.classList.contains('show')){
            bootstrap.Modal.getInstance(createAccessCardModal).hide();
            new AddBackLinkToModal(createAccessCardModal, editSystemModal);
        }
        let editSystemGroupModal = document.getElementById('edit_system_group_modal');
        if(editSystemGroupModal && editSystemGroupModal.classList.contains('show')){
            bootstrap.Modal.getInstance(editSystemGroupModal).hide();
            new AddBackLinkToModal(editSystemGroupModal, editSystemModal);
        }
    }
    /** If user click on pencil next to text, transform it into input */
    editSystemInput(){
        let form = $('#frm-generalForms-editSystemsForm-editSystemsForm');
        form.find('.edit-row .edit-button').on('click', function(e) {
            let mainDiv = $(this).closest('.edit-row');
            let toShow = mainDiv.find('.d-none.edit-show');
            toShow.removeClass('d-none edit-show');

            if($(this).hasClass('change-basic-system')){
                form.find('.service-container').removeClass('d-none');
                let type = form.find('select[name=type]');
                let protocol = form.find('select[name=protocol]');
                type.select2({minimumResultsForSearch: 0});
                protocol.select2({minimumResultsForSearch: -1});
            } else if($(this).hasClass('change-advanced-system')){
                form.find('.host-container').removeClass('d-none');
            }

            $(this).closest('.edit-remove').remove();
        });
    }
    async initTagifyInEditSystemForm(groupsArr) {
        const thisClass = this;
        const groupsInput = document.querySelector('#frm-generalForms-editSystemsForm-editSystemsForm input[name=groups]');
        let notice = $('#editSystemFormGroupNotice');
        if (groupsInput) {
            if (!thisClass.systemGroups) {
                thisClass.systemGroups = await fetch('/systems/?do=getSystemGroups&organizationID=' + thisClass.organizationID)
                    .then(response => {
                        if (!response.ok) {
                            throw new Error(response.statusText)
                        }
                        return response.json();
                    });
            }
            let tagify = new SystemGroupsTagify(groupsInput, thisClass.systemGroups);
            tagify.on('add', function (e) {
                if (e.detail.data.accessCards && notice) {
                    notice.removeClass('d-none');
                }
            }).on('remove', function (e) {
                let values = e.detail.tagify.value;
                for (let i in values) {
                    if (values[i].accessCards === true) {
                        break;
                    }
                }
                notice.addClass('d-none');
            });
            let names = [];
            for (let i = 0; i < groupsArr.length; i++) {
                names[i] = groupsArr[i]['name'];
            }
            tagify.addTags(names);
        }
    }
}
window.EditSystemForm = EditSystemForm;